export default {
  settingWarehouse: {
    storehouse: 'Warehouse',

    table: {
      storehouse: 'Warehouse',
      logistics: 'Specified logistics',
      logisticsBusiness: 'Specified logistics service',
      isExpressDelivery: 'Delivery Express',
      returnExpress: 'Return Express',
      priority: 'Priority Level',
      updater: 'Updated By',
      lastUpdated: 'Last Updated Time'
    },

    addAndEdit: {
      editWarehouse: 'Edit warehouse configuration',
      addWarehouse: 'Create warehouse configuration',
      code: 'Warehouse Code',
      selectWarehouse: 'Select Warehouse',
      name: 'Warehouse Name',
      warehouseText: 'Please select warehouse',
      logistics: 'Specified Logistics',
      business: 'Specified Business',
      logisticsText: 'Please select the associated logistics provider first',
      priority: 'Priority Level',
      priorityText: 'The smaller the value, the higher the priority',
      express: 'Delivery Express',
      returnExpress: 'Return Express',
      selectLogistics: 'Please select the specified logistics',
      selectBusiness: 'Please select the specified business',
      selectPriority: 'Please enter priority level',
    }
  }
};
